import React from "react";
import "./benefits.css";
import { useNavigate } from "react-router-dom";

const Benefits = ({ title, items = [], imgSrc, ctaLabel = "Comenzar", ctaHref }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (ctaHref) navigate(ctaHref);
  };

  return (
    <section className="benefits">
      <div className="benefits__inner">
        <h2 className="benefits__title">{title}</h2>
        <div className="benefits__grid">
          <div className="benefits__list">
            {items.map(({ t, d, icon }, i) => (
              <div key={i} className="benefits__item">
                {icon}
                <div className="benefits__item-content">
                  <span className="benefits__item-title">{t}</span>
                  <span className="benefits__item-desc">{d}</span>
                </div>
              </div>
            ))}
          </div>
          <div
            className="benefits__image-wrap"
            style={{ justifyItems: "center" }}>
            <img src={imgSrc} alt={title} className="benefits__image" />
            <div>
              {ctaLabel && (
                <button className="benefits__btn" onClick={ctaHref ? handleClick : undefined}>{ctaLabel}</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Benefits;
